import ExpandedCategory from './ExpandedCategory/ExpandedCategory';

const StoreHomeNew = (props) => {
  const { categoryCardsData } = props;
  return (
    <>
      <ExpandedCategory newPage={true} categoryData={categoryCardsData} />
    </>
  );
};

export default StoreHomeNew;
